import { faArrowToBottom, faFileAlt } from '@fortawesome/pro-regular-svg-icons'
import { ButtonIcon, Icon, Popover, State, Toast } from '@seiue/ui'
import { downloadFile, isArray } from '@seiue/util'
import { UploadFile } from 'antd'
import { FieldTypeEnum, InformalReflection } from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'
import React, { useState } from 'react'
import styled from 'styled-components'
import {
  colRenderSelector,
  getChildrenColumn,
  getChildrenDataSource,
  optionValueToLabel,
  urlRender,
} from './utils'
import { ColumnType } from 'antd/lib/table'
import { StyledTable } from 'packages/components/DataTable'
import humps from 'humps'
import { CusFieldRespond } from './types'

/**
 * 生源池数据在表格中的显示形式
 *
 * @param field - Object
 * @param text - 表格当前单元格的内容
 * @returns React.ReactNode
 */
export const ColumnsRender: React.FC<{
  field: CusFieldRespond
  text: AnyType
  record?: InformalReflection
}> = ({ field, text, record }) => {
  const [loading, setLoading] = useState<boolean>(false)

  const fileDownload = async (name: string, url: string) => {
    try {
      setLoading(true)
      await downloadFile(name, url)
      setLoading(false)
    } catch (error) {
      Toast.warning('下载失败')
      setLoading(false)
    }
  }
  const { type, label, name, options, children } = field

  if (colRenderSelector[humps.camelize(name)]) {
    return <span>{colRenderSelector[humps.camelize(name)](text)}</span>
  }

  if (type === FieldTypeEnum.Product && record) {
    if (children?.length) {
      const fields = record.fields ? record.fields[name as keyof object] : {}
      const childrenData = fields && Array.isArray(fields) ? fields : []
      return (
        <Popover
          placement="topRight"
          title={
            <StyledTable
              columns={getChildrenColumn(children, label === '证件')}
              dataSource={getChildrenDataSource(record, field)}
              rowKey={(r, i) => {
                return `${i}`
              }}
            />
          }
        >
          <InnerPopover>
            {label === '证件'
              ? record.idcard
                ? '1'
                : '0'
              : `${childrenData.length}`}
          </InnerPopover>
        </Popover>
      )
    }
  }

  if (type === FieldTypeEnum.Attachment || name === 'avatar') {
    let dataSource = isArray(text) ? text : []
    if (name === 'avatar' && text) {
      dataSource = [
        {
          name: text.slice(text.lastIndexOf('/') + 1),
          url: text,
        },
      ]
    }
    const columns: ColumnType<AnyType>[] = [
      {
        title: label,
        key: 'name',
        dataIndex: 'name',
        render: (r: string, record: UploadFile) => {
          return (
            <AttachWrapper>
              <div>
                <Icon icon={faFileAlt} />
                <AttachNameWrapper
                  href={record.url}
                  target="_blank"
                >
                  {record.name}
                </AttachNameWrapper>
              </div>
              {loading ? (
                <State.Loading style={{ width: 10, minHeight: 10 }} />
              ) : (
                <ButtonIcon
                  icon={faArrowToBottom}
                  onClick={async () => {
                    await fileDownload(record.name, record.url || '')
                  }}
                />
              )}
            </AttachWrapper>
          )
        },
      },
    ]
    return (
      <Popover
        placement="topRight"
        title={
          <StyledTable
            columns={columns}
            dataSource={dataSource}
            rowKey={(r, i) => {
              return `${i}`
            }}
          />
        }
      >
        <AttachNumWrapper>{dataSource.length}</AttachNumWrapper>
      </Popover>
    )
  } else {
    const finalText = optionValueToLabel(text, type, options)
    const showText = isArray(finalText)
      ? finalText.join(',')
      : urlRender(finalText)
    // TODO 临时隐藏
    // if (['admissionedAt', 'archivedAt'].includes(humps.camelize(name))) {
    //   showText = showText ? `${showText}`.slice(0, 10) : showText
    // }
    return <>{showText}</>
  }
}

const AttachNumWrapper = styled.div`
  color: ${(props) => props.theme.brand._2};
  cursor: pointer;
`

const AttachNameWrapper = styled.a`
  color: ${(props) => props.theme.brand._2};
  cursor: pointer;
  margin: 0 10px;
`

const AttachWrapper = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const InnerPopover = styled.div`
  color: ${(props) => props.theme.brand._2};
  cursor: pointer;
`
